import { DesignTokens, GivelifyLink } from '@givelify/ui';
import { Snackbar, styled } from '@mui/material';

export const StyledSnackbar = styled(Snackbar)(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: '16px',
        padding: '14px 16px',
        border: `2px solid ${DesignTokens.color.borderComponentSuccess}`,
        background:
            'linear-gradient(0deg, rgba(235, 249, 239, 0.50) 0%, rgba(235, 249, 239, 0.50) 100%), rgba(255, 255, 255, 0.70)',
        color: '#000',
        [theme.breakpoints.down('tablet')]: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
        },
        [theme.breakpoints.down('mobile')]: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
        },
    },

    '& .MuiSnackbarContent-message': {
        padding: 0,
        '& .MuiTypography-root': {
            color: DesignTokens.color.textPrimary,
            fontWeight: 800,
            fontSize: '14px',
            wordBreak: 'break-word',
        },
    },

    '& .MuiSnackbarContent-action': {
        marginRight: 0,
    },
}));

export const DismissButton = styled(GivelifyLink)(() => ({
    color: DesignTokens.color.textSecondary,

    '&:hover': {
        color: DesignTokens.color.textSecondary,
        textDecoration: 'none',
    },
}));

export const SuccessMessageContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',

    [theme.breakpoints.down('mobile')]: {
        alignItems: 'flex-start',
    },
}));
